import React, { Fragment } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const range = (from, to, step = 1) => {
  let i = from;
  const range = [];
  while (i <= to) {
    range.push(i);
    i += step;
  }
  return range;
};
const Paginate = ({ pageCount, pageIndex, gotoPage, previousPage, nextPage }) => {
  const fetchPageNumbers = () => {
    const pageNeighbours = 2;
    const totalNumbers = pageNeighbours;
    const totalBlocks = Math.min(totalNumbers, pageCount);
    const currentPage = pageIndex;
    const totalPages = pageCount;
    if (totalPages > totalBlocks) {
      const startPage = Math.max(1, currentPage - pageNeighbours);
      const endPage = Math.min(totalPages, currentPage + pageNeighbours);
      let pages = range(startPage, endPage);
      const hasLeftSpill = startPage > 2;
      const hasRightSpill = totalPages - endPage > 1;
      const spillOffset = totalNumbers - (pages.length + 1);
      switch (true) {
        case hasLeftSpill && hasRightSpill:
        default: {
          pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
          break;
        }
      }
      return [...pages];
    }
    return range(1, totalPages);
  };
  const pages = fetchPageNumbers();
  return (
    <>
      <Fragment>
        <Pagination
          className="pagination justify-content-end mb-0 mr-5"
          listClassName="justify-content-end mb-0"
          style={{
            backgroundColor: "#E7F1FD",
            borderRadius: "20px",
            position: "relative"
          }}
        >
          {pages.map((page) => {
            if (page === LEFT_PAGE)
              return (
                <PaginationItem key={page}>
                  <PaginationLink
                    className="d-flex align-items-center justify-content-center"
                    onClick={() => previousPage()}
                    style={{
                      backgroundColor: "#E7F1FD",
                      color: "#1273EB",
                      border: "none",
                      position: "absolute",
                      borderRadius: "50%",
                      left: "-50px",
                      width: "36px",
                      height: "36px",
                      boxShadow: "none",
                      outline: "none"
                    }}
                  >
                    <i className="fas fa-lg fa-angle-left"></i>
                  </PaginationLink>
                </PaginationItem>
              );
            if (page === RIGHT_PAGE)
              return (
                <PaginationItem key={page}>
                  <PaginationLink
                    className="d-flex align-items-center justify-content-center"
                    onClick={() => nextPage()}
                    style={{
                      backgroundColor: "#E7F1FD",
                      color: "#1273EB",
                      border: "none",
                      position: "absolute",
                      borderRadius: "50%",
                      right: "-50px",
                      width: "36px",
                      height: "36px",
                      boxShadow: "none",
                      outline: "none"
                    }}
                  >
                    <i className="fas fa-lg fa-angle-right" />
                  </PaginationLink>
                </PaginationItem>
              );
            return (
              <PaginationItem
                key={page}
                className={
                  page - 1 === pageIndex
                    ? "active d-flex align-items-center justify-content-center"
                    : ""
                }
                style={
                  page - 1 === pageIndex
                    ? {
                        backgroundColor: "#1273EB",
                        color: "white !important",
                        // transform: "scale(1.1)",
                        borderRadius: "50%",
                        // width: "100%"
                        width: "36px",
                        height: "36px",
                        boxShadow: "none",
                        border: "none",
                        outline: "none"
                      }
                    : null
                }
              >
                <PaginationLink
                  onClick={() => gotoPage(page - 1)}
                  className="d-flex align-items-center justify-content-center"
                  style={
                    page - 1 === pageIndex
                      ? {
                          border: "none",
                          background: "transparent",
                          color: "#fff",
                          borderRadius: "50%",
                          lineHeight: "1",
                          width: "36px",
                          height: "36px",
                          boxShadow: "none",
                          outline: "none"
                        }
                      : {
                          border: "none",
                          background: "transparent",
                          color: "#363636",
                          borderRadius: "50%",
                          width: "36px",
                          height: "36px",
                          boxShadow: "none",
                          outline: "none"
                        }
                  }
                >
                  {page}
                </PaginationLink>
              </PaginationItem>
            );
          })}
        </Pagination>
      </Fragment>
    </>
  );
};
export default Paginate;
